import { COST_CEILING_DISABLED, getCostCeiling, } from '@debbie/common/dist/economy/helpers/interest/index.js';
import { useMemo } from 'react';
import { useCase } from '../cases/index.js';
import { LoadingState, h } from '../index.js';
import { useVoucherTypes } from '../voucher-types/index.js';
const LOADING = {
    loadingState: LoadingState.Loading,
};
// Voucher types are only needed when the case has a ceiling.
export const useCostCeiling = (caseId) => {
    const caseLoader = useCase(caseId);
    const singleCase = h.hasData(caseLoader) ? caseLoader.data : null;
    const enabled = singleCase?.costCeilingEnabled === true;
    const voucherTypesLoader = useVoucherTypes({ enabled });
    const voucherTypes = h.hasData(voucherTypesLoader)
        ? voucherTypesLoader.data
        : null;
    const error = h.isError(caseLoader)
        ? caseLoader.error
        : enabled && h.isError(voucherTypesLoader)
            ? voucherTypesLoader.error
            : null;
    return useMemo(() => {
        if (error != null) {
            return { loadingState: LoadingState.Error, error };
        }
        if (singleCase == null) {
            return LOADING;
        }
        if (!enabled) {
            return { loadingState: LoadingState.Loaded, data: COST_CEILING_DISABLED };
        }
        if (voucherTypes == null) {
            return LOADING;
        }
        return {
            loadingState: LoadingState.Loaded,
            data: getCostCeiling(singleCase, voucherTypes),
        };
    }, [error, singleCase, enabled, voucherTypes]);
};
//# sourceMappingURL=index.js.map